import React, { memo, useState } from 'react';
import Image from 'utils/packages/rnFastImage';
import { rem } from 'design-system/values';
import { AvatarWrapper } from './AvatarWrapper';
import { AvatarText } from './AvatarText';
export const Avatar = memo(({ imageUrl, name, lastName, color, fontColor, size, style, primary, borderWidth = 0, resizeMode, xxSmall, xSmall, small, medium, large, }) => {
    const [hasError, setHasError] = useState(false);
    const imageStyle = {
        width: rem(size),
        height: rem(size),
        borderRadius: size / 2,
    };
    return (<AvatarWrapper color={color} size={size} style={style} borderWidth={borderWidth}>
        {imageUrl && !hasError ? (<Image style={imageStyle} source={typeof imageUrl === 'string' ? { uri: imageUrl } : imageUrl} resizeMode={resizeMode} onError={() => setHasError(true)}/>) : (<AvatarText primary={primary} name={name} lastName={lastName} fontColor={fontColor} xxSmall={xxSmall} xSmall={xSmall} small={small} medium={medium} large={large}/>)}
      </AvatarWrapper>);
});
